import Image from "next/image";
import { PropsWithChildren } from "react";
import { getSiteImageFullPath } from "~/lib/siteMedia";

export interface IErrorMessageComponent {}

const ErrorMessageComponent: React.FC<PropsWithChildren<IErrorMessageComponent>> = ({
	children,
}) => {
	return (
		<div className={`grow shrink-0 flex items-stretch`} id="page_error">
			<div className="w-full h-full max-w-screen-xl mx-auto">
				<div className="flex flex-row items-center h-full mx-4 my-4 sm:mx-8">
					<div className="sm:block hidden relative aspect-[28/30] basis-1 grow m-8">
						<Image
							alt=""
							src={getSiteImageFullPath("error/cow.png")}
							priority
							fill
							className="object-contain"
							sizes="(min-width: 1280px) 544px, (min-width: 640px) 50vw, 1px"
						/>
					</div>
					<div className="m-1 2xs:m-8 basis-1 grow">
						<h1
							className="flex flex-row items-center gap-2 text-5xl font-semibold 2xs:text-9xl text-epic-light-red font-fun"
							id="heading_ope"
						>
							<div>{"Ope!"}</div>
							<div className="sm:hidden block relative aspect-[28/30] h-16 2xs:h-32">
								<Image
									alt=""
									src={getSiteImageFullPath("error/cow.png")}
									priority
									fill
									className="object-contain"
									sizes="(min-width: 640px) 1px, 120px"
								/>
							</div>
						</h1>
						<div className="py-6 text-2xl">{children}</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ErrorMessageComponent;
